/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetDownloadIcon32Regular = forwardRef('NetDownloadIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M16 2.25a1 1 0 0 1 1 1v18.468c.115-.066.226-.145.329-.237l7.007-6.228a1 1 0 0 1 1.328 1.494l-7.007 6.229a4 4 0 0 1-5.315 0l-7.006-6.229a1 1 0 1 1 1.328-1.494l7.007 6.228c.103.092.214.17.329.237V3.25a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M3.5 28.25a1 1 0 0 1 1-1h23a1 1 0 1 1 0 2h-23a1 1 0 0 1-1-1Z" })));
});
